// src/pages/AdminEmailList.js

import React, { useState, useEffect } from 'react';
import './AdminEmailList.css';
import api from '../services/api';

export default function AdminEmailList() {
  const [emails, setEmails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.fetchEmails()
      .then(data => {
        setEmails(data);
      })
      .catch(err => {
        console.error(err);
        setError('Failed to load emails.');
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="email-list-page">
      <h2 className="page-title">Subscribed Emails</h2>

      {loading ? (
        <div className="loader">Loading...</div>
      ) : error ? (
        <div className="error">{error}</div>
      ) : emails.length === 0 ? (
        <div className="empty-state">No subscriptions yet.</div>
      ) : (
        <div className="email-grid">
          {emails.map(({ id, email, subscribedAt }) => (
            <div key={id} className="email-card">
              <div className="email-row">
                <span className="email-text">{email}</span>
                <span className="date-text">
                  {new Date(subscribedAt).toLocaleString()}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
